import { render, staticRenderFns } from "./OrganizationsForm.vue?vue&type=template&id=2e6dd18c"
import script from "./OrganizationsForm.vue?vue&type=script&lang=js"
export * from "./OrganizationsForm.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsForm.vue?vue&type=style&index=0&id=2e6dd18c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports